import React, { useState, useEffect } from "react";
import "../../Sidebar/Pages/Pricing-plan.css";
import "./dashboard.css";
import { calculatePackage, fetchPackageApi, payPlanAmount } from "../../actioncreators/actioncreators";
import { useSuspension } from "../../contexts/SuspensionContext";

// AddUserPopup component


const Subscription = () => {
  // Suspension check
  const { isSuspended } = useSuspension();
  const [isAnnual, setIsAnnual] = useState(false);
  const [plans, setPlans] = useState([]);
  const [allFeatures, setAllFeatures] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogPlan, setDialogPlan] = useState(null);
  const [userCount, setUserCount] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [billingFreq, setBillingFreq] = useState('monthly');
  const [calculatedPrice, setCalculatedPrice] = useState(null);
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [subscribeMode, setSubscribeMode] = useState(false);
  const [addUsersMode, setAddUsersMode] = useState(false);
  const [addUsersCount, setAddUsersCount] = useState(1);
  const [upgradeMode, setUpgradeMode] = useState(false);
  const [upgradeMode2, setUpgradeMode2] = useState(false);
  const [upgradeUsersCount, setUpgradeUsersCount] = useState(1);
  const [upgradeUsersCount2, setUpgradeUsersCount2] = useState(1);
  const [renewMode, setRenewMode] = useState(false);
  const [upgradeStartDate, setUpgradeStartDate] = useState('');
  const [renewStartDate, setRenewStartDate] = useState('');
  const [isCalcLoading, setIsCalcLoading] = useState(false);
  const [isPayLoading, setIsPayLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const AddUserPopup = ({
    open,
    onClose,
    plan,
    subscriptionDetails,
    addUsersCount,
    setAddUsersCount,
    calculatedPrice,
    setCalculatedPrice
  }) => {
    const [responseData, setResponseData] = useState(null);
    
    // Move useEffect before any conditional returns
    useEffect(() => {
      const calculateAutomatically = async () => {
        if (!open || !plan || !subscriptionDetails || !addUsersCount) return;
        
        const currentUsers = Number(subscriptionDetails?.max_users) || 0;
        try {
          const payload = {
            billingFrequency: isAnnual ? "YEARLY" : "MONTHLY",
            subscriptionAction: "UPDATE",
            totalUser: currentUsers + addUsersCount,
            packageId: plan.package_id,
            // subscriptionStartDate: formatDateForPayload(startDate)
          };

          const response = await calculatePackage(payload);
          setCalculatedPrice(Number(response.subscriptionAmount));
          setResponseData(response);
        } catch (error) {
          console.error('Error calculating:', error);
        }
      };

      calculateAutomatically();
    }, [open, plan, subscriptionDetails, addUsersCount, isAnnual, startDate]);

    if (!open || !plan || !subscriptionDetails) return null;

    // Add currentUsers variable
    const currentUsers = Number(subscriptionDetails?.max_users) || 0;

    // Calculate remaining days (date only, ignore time)
    const today = new Date();
    const endDate = new Date(subscriptionDetails.subscription_end_date);
    // Zero out time for both dates
    const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    console.log("today (date only):", todayDateOnly);
    console.log("endDate (date only):", endDateOnly);
    const diffTime = endDateOnly - todayDateOnly;
    console.log("diffTime (ms):", diffTime);
    const remainingDays = Math.max(Math.ceil(diffTime / (1000 * 60 * 60 * 24)), 0);
    console.log("remainingDays:", remainingDays);

    // Use monthly_price_per_user from current selected plan for daily charge calculation
    const monthlyPricePerUser = Number(plan.monthly_price_per_user) || 0;
    console.log("monthlyPricePerUser:", monthlyPricePerUser);
    const perDayPrice = monthlyPricePerUser / 30;
    console.log("perDayPrice:", perDayPrice);
    console.log("addUsersCount:", addUsersCount);

    const handleCalculate = async () => {
      try {
        const payload = {
          billingFrequency: isAnnual ? "YEARLY" : "MONTHLY",
          subscriptionAction: "UPDATE",
          totalUser: currentUsers + addUsersCount,
          packageId: plan.package_id,
          subscriptionStartDate: formatDateForPayload(startDate)
        };
 
        const response = await calculatePackage(payload);
        console.log('API Response:', response);
        // Update both price and response data in one go
        setCalculatedPrice(Number(response.subscriptionAmount));
        setResponseData(response);
        
        // Show the details section by ensuring both values are set
        // setTimeout(() => {
        //   setCalculatedPrice(Number(response.subscriptionAmount));
        //   setResponseData(response);
        // }, 0);
      } catch (error) {
        console.error('Error calculating:', error);
        // setCalculatedPrice(0);
        // setResponseData(null);
      }
    };
    const handlePayAdduserpopup = async () => {
      try {
        const payload = {
          billingFrequency: isAnnual ? "YEARLY" : "MONTHLY",
          subscriptionAction: "UPDATE",
          totalUser: currentUsers + addUsersCount,
          packageId: plan.package_id,
          // subscriptionStartDate: formatDateForPayload(startDate),
          amount: calculatedPrice
        };
        const response = await payPlanAmount(payload);
        console.log('API Response:', response);
        if (response && response.paymentLink) {
          if (response.subscriptionId) {
            localStorage.setItem('subscriptionId', response.subscriptionId);
            console.log('subscriptionId:', response.subscriptionId);
          }
          window.location.href = response.paymentLink;
        }
        onClose(); // Close popup after successful payment
      } catch (error) {
        console.error('Error paying:', error);
      }
    };

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.25)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        onClick={onClose}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 10,
            minWidth: 320,
            maxWidth: 400,
            padding: 28,
            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            position: "relative"
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <h4 style={{ margin: 0, marginBottom: 18, color: "#fd5f07" }}>
            Add User to {plan.package_name}
          </h4>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", fontWeight: 1000, marginBottom: 4 }}>
              Current Users
            </label>
            <input
              type="number"
              value={subscriptionDetails?.max_users || 0}
              disabled
              style={{
                width: "100%",
                padding: 6,
                borderRadius: 4,
                border: "1px solid #ccc",
                background: "#f5f5f5"
              }}
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", fontWeight: 1000, marginBottom: 4 }}>
              Add no of users
            </label>
            <input
              type="number"
              min={1}
              value={addUsersCount}
              onChange={(e) => setAddUsersCount(Number(e.target.value))}
              style={{
                width: "100%",
                padding: 6,
                borderRadius: 4,
                border: "1px solid #ccc"
              }}
            />
          </div>
          {/* <div style={{ marginBottom: 14, fontSize: 13, color: "#888" }}>
            Monthly Price: {monthlyPricePerUser.toFixed(2)}<br />
            Per Day Price: {perDayPrice.toFixed(2)}<br />
            Remaining Days: {remainingDays}
          </div> */}
          {calculatedPrice !== null && (
            <div style={{ marginTop: 18, textAlign: "center" }}>
              <span style={{ fontWeight: 600, color: "#fd5f07", fontSize: 18 }}>
                Payable Amount: ₹{Number(calculatedPrice).toFixed(2)}
              </span>
              <div style={{ fontSize: 13, color: "#888" }}>
                {responseData ? (
                  <>
                    Per Month Price: {formatPriceDisplay(responseData.perMonthPrice)}<br />
                    Remaining Amount: {formatPriceDisplay(responseData.remainingAmount)}<br />
                    Remaining Days: {responseData.remainingDays}<br />
                    Subscribed Users: {responseData.subscribedUsers}
                  </>
                ) : (
                  <span>Click Calculate to see subscription details</span>
                )}
              </div>
              <button
                style={{
                  background: isSuspended ? "#ccc" : "#28a745",
                  color: isSuspended ? "#888" : "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "10px 32px",
                  fontWeight: 600,
                  fontSize: 16,
                  cursor: isSuspended ? "not-allowed" : "pointer",
                  marginTop: 10,
                  opacity: isSuspended ? 0.6 : 1
                }}
                onClick={isSuspended ? undefined : handlePayAdduserpopup}
                disabled={isSuspended}
                title={isSuspended ? "Actions disabled - Organization is suspended" : ""}
              >
                Pay Now
              </button>
            </div>
          )}
          <button
            onClick={() => {
              onClose();
              setCalculatedPrice(null);
            }}
            style={{
              position: "absolute",
              top: 8,
              right: 12,
              background: "none",
              border: "none",
              fontSize: 22,
              color: "#888",
              cursor: "pointer"
            }}
            title="Close"
          >
            &times;
          </button>
        </div>
      </div>
    );
  };
  const fetchPackages = async () => {
    try {
      const response = await fetchPackageApi();
      if (response && response.packages) {
        setPlans(response.packages);

        // Collect all unique features across all packages
        const featureMap = {};
        response.packages.forEach(pkg => {
          pkg.features.forEach(f => {
            featureMap[f.feature_id] = f;
          });
        });
        // Sort features by name for consistent display
        const featuresArr = Object.values(featureMap).sort((a, b) =>
          a.feature_name.localeCompare(b.feature_name)
        );
        setAllFeatures(featuresArr);

        // Preset selected plan based on subscriptionDetails.package_id if available
        if (response.subscriptionDetails && response.subscriptionDetails.package_id) {
          setSelectedPlan(response.subscriptionDetails.package_id);
          setSubscriptionDetails(response.subscriptionDetails);
        } else {
          // Fallback: Basic if exists, else first
          const basicPlan = response.packages.find(p => p.package_type === "Basic");
          setSelectedPlan(basicPlan ? basicPlan.package_id : response.packages[0]?.package_id);
          setSubscriptionDetails(null);
        }
      }
    } catch (err) {
      // Handle error if needed
    }
  };

  useEffect(() => {
    fetchPackages();
  }, []);

  // Custom CSS styles for transitions
  const customStyles = {
    planColumn: {
      transition: "all 0.3s ease-in-out",
      borderWidth: "2px",
      borderStyle: "solid",
      borderColor: "transparent",
      position: "relative", // Add position relative for z-index to work
      zIndex: 1, // Base z-index for all cards
      marginTop: "5px", // Add top margin to accommodate for translateY
      marginBottom: "5px" // Balance with bottom margin
    },
    selectedPlan: {                                                                                                                                                                                     
      overflow: "visible" // Ensure borders aren't clipped
    },
    buttonTransition: {
      transition: "all 0.3s ease-in-out"
    }
  };

  // Handle plan selection
  const handlePlanSelect = (planId) => {
    setSelectedPlan(planId);
  };

  // Open dialog for a plan
  const handleAddUsersClick = (plan, isSubscribe = false, isAddUsers = false) => {
    setDialogPlan(plan);
    setUserCount(plan.min_users || 1);
    setAddUsersCount(1);
    setStartDate('');
    setBillingFreq(isAnnual ? 'yearly' : 'monthly');
    setDialogOpen(true);
    setSubscribeMode(isSubscribe);
    setAddUsersMode(isAddUsers);
    setCalculatedPrice(null);
  };

  // Close dialog
  const handleDialogClose = () => {
    setDialogOpen(false);
    setDialogPlan(null);
  };

  // Calculation handler
  const handleCalculate = () => {
    if (!dialogPlan) return;
    let price = 0;
    if (billingFreq === "monthly") {
      // Monthly price per user * user count
      price = (dialogPlan.monthly_price_per_user || 0) * userCount;
    } else if (billingFreq === "yearly") {
      // Monthly price billed annually * 12 * user count
      price = (dialogPlan.monthly_price_user_billed_annually || 0) * 12 * userCount;
    }
    setCalculatedPrice(price);
  };

  // Add this useEffect for subscribeMode calculation
  useEffect(() => {
    if (
      dialogOpen &&
      dialogPlan &&
      subscribeMode &&
      userCount >= (dialogPlan.min_users || 1) &&
      startDate
    ) {
      console.log("SubscribePopup: Triggering calculation for subscribeMode", {
        userCount,
        startDate,
        dialogPlan
      });
      const payload = {
        billingFrequency: isAnnual ? "YEARLY" : "MONTHLY",
        subscriptionAction: "RENEW",
        totalUser: userCount,
        packageId: dialogPlan.package_id,
        subscriptionStartDate: formatDateForPayload(startDate)
      };
      calculatePackage(payload)
        .then(response => {
          console.log("SubscribePopup: Calculation response", response);
          setCalculatedPrice(Number(response.subscriptionAmount));
        })
        .catch(error => {
          console.error("SubscribePopup: Error calculating", error);
        });
    }
  }, [dialogOpen, dialogPlan, subscribeMode, userCount, startDate, isAnnual]);

  // Helper to check if selected plan is trial
  const isTrialSelected = (() => {
    if (!subscriptionDetails || !plans.length) return false;
    const trialPlan = plans.find(p => p.package_type === "Trial");
    return trialPlan && subscriptionDetails.package_id === trialPlan.package_id;
  })();

  // Helper to check if selected plan is Basic or Advance
  const isBasicOrAdvanceSelected = (() => {
    if (!subscriptionDetails || !plans.length) return false;
    const selected = plans.find(p => p.package_id === subscriptionDetails.package_id);
    return selected && (selected.package_type === "Basic" || selected.package_type === "Advance");
  })();

  // UpgradePlanPopup component (like AddUserPopup, but for upgrade)
  const UpgradePlanPopup = ({
    open,
    onClose,
    plan,
    subscriptionDetails,
    upgradeUsersCount,
    setUpgradeUsersCount,
    calculatedPrice,
    setCalculatedPrice,
    startDate,
    setStartDate
  }) => {
    const [responseData, setResponseData] = useState(null);
    
    // Move useEffect before conditional return
    useEffect(() => {
      const calculateAutomatically = async () => {
        if (!open || !plan || !subscriptionDetails || !startDate || !upgradeUsersCount) return;
        
        const currentUsers = Number(subscriptionDetails?.max_users) || 0;
        try {
          const payload = {
            billingFrequency: isAnnual ? "YEARLY" : "MONTHLY",
            subscriptionAction: "RENEW",
            totalUser: currentUsers + upgradeUsersCount,
            packageId: plan.package_id,
            subscriptionStartDate: formatDateForPayload(startDate)
          };
          
          const response = await calculatePackage(payload);
          setCalculatedPrice(Number(response.subscriptionAmount));
          setResponseData(response);
        } catch (error) {
          console.error('Error calculating upgrade:', error);
        }
      };

      calculateAutomatically();
    }, [open, plan, subscriptionDetails, upgradeUsersCount, startDate, isAnnual]);

    if (!open || !plan || !subscriptionDetails) return null;

    // Calculate remaining days (date only, ignore time)
    const today = new Date();
    const endDate = new Date(subscriptionDetails.subscription_end_date);
    const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    const diffTime = endDateOnly - todayDateOnly;
    const remainingDays = Math.max(Math.ceil(diffTime / (1000 * 60 * 60 * 24)), 0);

    // Advance Monthly Price from response (plan is Advance)
    const advanceMonthlyPrice = Number(plan.monthly_price_per_user) || 0;
    // Per day price = Advance Monthly Price / 30
    const perDayPrice = advanceMonthlyPrice / 30;
    // User count = current users + input upgrade users
    const currentUsers = Number(subscriptionDetails?.max_users) || 0;
    const totalUsers = currentUsers + upgradeUsersCount;

    // Existing Per day price from subscriptionDetails
    const existingPerDayPrice = Number(subscriptionDetails.daily_charge_per_user) || 0;

    // Calculation
    // pkg price = perDayPrice * totalUsers * remainingDays
    // remaining price = existingPerDayPrice * totalUsers * remainingDays
    // payable = pkg price - remaining price
    const handleCalculate = async () => {
      if (!startDate) return;
      try {
        const payload = {
          billingFrequency: isAnnual ? "YEARLY" : "MONTHLY",
          subscriptionAction: "RENEW",
          totalUser: totalUsers,
          packageId: plan.package_id,
          subscriptionStartDate: formatDateForPayload(startDate)
        };
        const response = await calculatePackage(payload);
        console.log('API Response:', response);
        setCalculatedPrice(Number(response.subscriptionAmount));
        setResponseData(response);
        // setTimeout not needed
      } catch (error) {
        console.error('Error calculating upgrade:', error);
        // setCalculatedPrice(0);
        // setResponseData(null);
      }
    };
    const handlePayUpgradePlan = async () => {
      try {
        const payload = {
          billingFrequency: isAnnual ? "YEARLY" : "MONTHLY",
          subscriptionAction: "RENEW",
          totalUser: currentUsers + upgradeUsersCount,
          packageId: plan.package_id,
          subscriptionStartDate: formatDateForPayload(startDate),
          amount: calculatedPrice
        };
        const response = await payPlanAmount(payload);
        console.log('API Response:', response);
        if (response && response.paymentLink) {
          if (response.subscriptionId) {
            localStorage.setItem('subscriptionId', response.subscriptionId);
            console.log('subscriptionId:', response.subscriptionId);
          }
          window.location.href = response.paymentLink;
        }
        onClose();
      } catch (error) {
        console.error('Error paying:', error);
      }
    };

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.25)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        onClick={onClose}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 10,
            minWidth: 320,
            maxWidth: 400,
            padding: 28,
            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            position: "relative"
          }}
          onClick={e => e.stopPropagation()}
        >
          <h4 style={{ margin: 0, marginBottom: 18, color: "#fd5f07" }}>
            Upgrade to {plan.package_name}
          </h4>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", fontWeight: 1000, marginBottom: 4 }}>
              Current Users
            </label>
            <input
              type="number"
              value={currentUsers}
              disabled
              style={{
                width: "100%",
                padding: 6,
                borderRadius: 4,
                border: "1px solid #ccc",
                background: "#f5f5f5"
              }}
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", fontWeight: 1000, marginBottom: 4 }}>
              Upgrade no of users
            </label>
            <input
              type="number"
              min={1}
              value={upgradeUsersCount}
              onChange={e => setUpgradeUsersCount(Number(e.target.value))}
              style={{
                width: "100%",
                padding: 6,
                borderRadius: 4,
                border: "1px solid #ccc"
              }}
            />
          </div>
          {/* Add Subscription Start Date field */}
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", fontWeight: 1000, marginBottom: 4 }}>
              Subscription Start Date
            </label>
            <input
              type="date"
              value={startDate}
              onChange={e => setStartDate(e.target.value)}
              style={{
                width: "100%",
                padding: 6,
                borderRadius: 4,
                border: "1px solid #ccc"
              }}
            />
          </div>
          {/* <div style={{ marginBottom: 14, fontSize: 13, color: "#888" }}>
            Advance Monthly Price: {advanceMonthlyPrice.toFixed(2)}<br />
            Per Day Price: {perDayPrice.toFixed(2)}<br />
            Existing Per Day Price: {existingPerDayPrice.toFixed(2)}<br />
            Total Users: {totalUsers}<br />
            Remaining Days: {remainingDays}
          </div> */}

          {/* Update Calculate button to require start date */}
          {calculatedPrice !== null && (
            <div style={{ marginTop: 18, textAlign: "center" }}>
              <span style={{ fontWeight: 600, color: "#fd5f07", fontSize: 18 }}>
                Payable Amount: ₹{Number(calculatedPrice).toFixed(2)}
              </span>
              <div style={{ fontSize: 13, color: "#888" }}>
                {responseData ? (
                  <>
                    Per Month Price: {formatPriceDisplay(responseData.perMonthPrice)}<br />
                    Remaining Amount: {formatPriceDisplay(responseData.remainingAmount)}<br />
                    Remaining Days: {responseData.remainingDays}<br />
                    Subscribed Users: {responseData.subscribedUsers}
                  </>
                ) : (
                  <span>Click Calculate to see subscription details</span>
                )}
              </div>
              <button
                style={{
                  background: isSuspended ? "#ccc" : "#28a745",
                  color: isSuspended ? "#888" : "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "10px 32px",
                  fontWeight: 600,
                  fontSize: 16,
                  cursor: isSuspended ? "not-allowed" : "pointer",
                  marginTop: 10,
                  opacity: isSuspended ? 0.6 : 1
                }}
                onClick={isSuspended ? undefined : handlePayUpgradePlan}
                disabled={isSuspended}
                title={isSuspended ? "Actions disabled - Organization is suspended" : ""}
              >
                Pay Now
              </button>
            </div>
          )}
          <button
            onClick={() => {
              onClose();
              setCalculatedPrice(null);
            }}
            style={{
              position: "absolute",
              top: 8,
              right: 12,
              background: "none",
              border: "none",
              fontSize: 22,
              color: "#888",
              cursor: "pointer"
            }}
            title="Close"
          >
            &times;
          </button>
        </div>
      </div>
    );
  };

  // RenewPackagePopup component
  const UpgradePlanPopup2 = ({
    open,
    onClose,
    plan,
    subscriptionDetails,
    upgradeUsersCount2,
    setUpgradeUsersCount2,
    calculatedPrice,
    setCalculatedPrice,
    startDate,
    setStartDate
  }) => {
    const [responseData, setResponseData] = useState(null);

    // Fix useEffect dependency array and logic
    useEffect(() => {
      const calculateAutomatically = async () => {
        if (!open || !plan || !subscriptionDetails || !startDate || !upgradeUsersCount2) return;

        const currentUsers = Number(subscriptionDetails?.max_users) || 0;
        try {
          const payload = {
            billingFrequency: isAnnual ? "YEARLY" : "MONTHLY",
            subscriptionAction: "RENEW",
            totalUser: currentUsers + upgradeUsersCount2,
            packageId: plan.package_id,
            subscriptionStartDate: formatDateForPayload(startDate)
          };

          const response = await calculatePackage(payload);
          setCalculatedPrice(Number(response.subscriptionAmount));
          setResponseData(response);
        } catch (error) {
          console.error('Error calculating upgrade:', error);
        }
      };

      calculateAutomatically();
    }, [open, plan, subscriptionDetails, upgradeUsersCount2, startDate, isAnnual]); // fixed dependencies

    if (!open || !plan || !subscriptionDetails) return null;

    // Calculate remaining days (date only, ignore time)
    const today = new Date();
    const endDate = new Date(subscriptionDetails.subscription_end_date);
    const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    const diffTime = endDateOnly - todayDateOnly;
    const remainingDays = Math.max(Math.ceil(diffTime / (1000 * 60 * 60 * 24)), 0);

    // Advance Monthly Price from response (plan is Advance)
    const advanceMonthlyPrice = Number(plan.monthly_price_per_user) || 0;
    // Per day price = Advance Monthly Price / 30
    const perDayPrice = advanceMonthlyPrice / 30;
    // User count = current users + input upgrade users
    const currentUsers = Number(subscriptionDetails?.max_users) || 0;
    const totalUsers = currentUsers + upgradeUsersCount2;

    // Existing Per day price from subscriptionDetails
    const existingPerDayPrice = Number(subscriptionDetails.daily_charge_per_user) || 0;

    // Calculation
    // pkg price = perDayPrice * totalUsers * remainingDays
    // remaining price = existingPerDayPrice * totalUsers * remainingDays
    // payable = pkg price - remaining price
    const handleCalculate = async () => {
      if (!startDate) return;
      try {
        const payload = {
          billingFrequency: isAnnual ? "YEARLY" : "MONTHLY",
          subscriptionAction: "RENEW",
          totalUser: totalUsers,
          packageId: plan.package_id,
          subscriptionStartDate: formatDateForPayload(startDate)
        };
        const response = await calculatePackage(payload);
        console.log('API Response:', response);
        setCalculatedPrice(Number(response.subscriptionAmount));
        setResponseData(response);
      } catch (error) {
        console.error('Error calculating upgrade:', error);
      }
    };
    const handlePayUpgradePlan = async () => {
      try {
        const payload = {
          billingFrequency: isAnnual ? "YEARLY" : "MONTHLY",
          subscriptionAction: "RENEW",
          totalUser: currentUsers + upgradeUsersCount2,
          packageId: plan.package_id,
          subscriptionStartDate: formatDateForPayload(startDate),
          amount: calculatedPrice
        };
        const response = await payPlanAmount(payload);
        console.log('API Response:', response);
        if (response && response.paymentLink) {
          if (response.subscriptionId) {
            localStorage.setItem('subscriptionId', response.subscriptionId);
            console.log('subscriptionId:', response.subscriptionId);
          }
          window.location.href = response.paymentLink;
        }
        onClose();
      } catch (error) {
        console.error('Error paying:', error);
      }
    };

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.25)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        onClick={onClose}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 10,
            minWidth: 320,
            maxWidth: 400,
            padding: 28,
            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            position: "relative"
          }}
          onClick={e => e.stopPropagation()}
        >
          <h4 style={{ margin: 0, marginBottom: 18, color: "#fd5f07" }}>
          Renew {plan.package_name} Package
          </h4>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", fontWeight: 1000, marginBottom: 4 }}>
              Current Users
            </label>
            <input
              type="number"
              value={currentUsers}
              disabled
              style={{
                width: "100%",
                padding: 6,
                borderRadius: 4,
                border: "1px solid #ccc",
                background: "#f5f5f5"
              }}
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", fontWeight: 1000, marginBottom: 4 }}>
              Add no of users
            </label>
            <input
              type="number"
              min={1}
              value={upgradeUsersCount2}
              onChange={e => setUpgradeUsersCount2(Number(e.target.value))}
              style={{
                width: "100%",
                padding: 6,
                borderRadius: 4,
                border: "1px solid #ccc"
              }}
            />
          </div>
          {/* Add Subscription Start Date field */}
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", fontWeight: 1000, marginBottom: 4 }}>
              Subscription Start Date
            </label>
            <input
              type="date"
              value={startDate}
              onChange={e => setStartDate(e.target.value)}
              style={{
                width: "100%",
                padding: 6,
                borderRadius: 4,
                border: "1px solid #ccc"
              }}
            />
          </div>
          {/* <div style={{ marginBottom: 14, fontSize: 13, color: "#888" }}>
            Advance Monthly Price: {advanceMonthlyPrice.toFixed(2)}<br />
            Per Day Price: {perDayPrice.toFixed(2)}<br />
            Existing Per Day Price: {existingPerDayPrice.toFixed(2)}<br />
            Total Users: {totalUsers}<br />
            Remaining Days: {remainingDays}
          </div> */}

          {/* Update Calculate button to require start date */}
          {calculatedPrice !== null && (
            <div style={{ marginTop: 18, textAlign: "center" }}>
              <span style={{ fontWeight: 600, color: "#fd5f07", fontSize: 18 }}>
                Payable Amount: ₹{Number(calculatedPrice).toFixed(2)}
              </span>
              <div style={{ fontSize: 13, color: "#888" }}>
                {responseData ? (
                  <>
                    Per Month Price: {formatPriceDisplay(responseData.perMonthPrice)}<br />
                    Remaining Amount: {formatPriceDisplay(responseData.remainingAmount)}<br />
                    Remaining Days: {responseData.remainingDays}<br />
                    Subscribed Users: {responseData.subscribedUsers}
                  </>
                ) : (
                  <span>Click Calculate to see subscription details</span>
                )}
              </div>
              <button
                style={{
                  background: isSuspended ? "#ccc" : "#28a745",
                  color: isSuspended ? "#888" : "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "10px 32px",
                  fontWeight: 600,
                  fontSize: 16,
                  cursor: isSuspended ? "not-allowed" : "pointer",
                  marginTop: 10,
                  opacity: isSuspended ? 0.6 : 1
                }}
                onClick={isSuspended ? undefined : handlePayUpgradePlan}
                disabled={isSuspended}
                title={isSuspended ? "Actions disabled - Organization is suspended" : ""}
              >
                Pay Now
              </button>
            </div>
          )}
          <button
            onClick={() => {
              onClose();
              setCalculatedPrice(null);
            }}
            style={{
              position: "absolute",
              top: 8,
              right: 12,
              background: "none",
              border: "none",
              fontSize: 22,
              color: "#888",
              cursor: "pointer"
            }}
            title="Close"
          >
            &times;
          </button>
        </div>
      </div>
    );
  };

  // Helper to check if Basic plan is selected
  const isBasicSelected = (() => {
    if (!subscriptionDetails || !plans.length) return false;
    const selected = plans.find(p => p.package_id === subscriptionDetails.package_id);
    return selected && selected.package_type === "Basic";
  })();

  // Add this helper function near the top of the file with other functions
  const formatDateForPayload = (selectedDate) => {
    // Always return date with time 00:00:00.000, even for today
    return selectedDate + ' 00:00:00.000';
  };

  // Utility function to format price display
  const formatPriceDisplay = (value) => {
    return (Number(value) || 0).toFixed(2);
  };

  return (
    <div className="pricing-page">
      <div className="pricing-header">
        <h4 className="text-warning fw-bold">Select the perfect plan for your business needs</h4>
        <div className="billing-selector">
          <span className={`billing-option ${!isAnnual ? 'selected' : ''}`}>Monthly</span>
          <div className="toggle-wrapper">
            <input
              type="checkbox"
              id="billing-toggle"
              checked={isAnnual}
              onChange={() => setIsAnnual(!isAnnual)}
            />
            <label htmlFor="billing-toggle" className="toggle" style={{ background: isAnnual ? "#fd5f07" : "#e2e8f0" }}>
              <div className="toggle-handle"></div>
            </label>
          </div>
          <span className={`billing-option ${isAnnual ? 'selected' : ''}`}>
            Yearly
             {/* <span className="discount-badge" style={{ background: "linear-gradient(90deg, #fd5f07, #ff7a00)" }}>Save 20%</span> */}
          </span>
        </div>
      </div>

      <div className="pricing-table-wrapper">
        <div className="pricing-table">
          {/* Features column */}
          <div className="features-column">
            <div className="column-header">
              <h3>Features</h3>
            </div>
            {allFeatures.map((feature, index) => (
              <div key={feature.feature_id} className="feature-row">
                <span>{feature.feature_name}</span>
              </div>
            ))}
            <div className="column-footer">
              <span></span>
            </div>
          </div>

          {/* Plans columns */}
          {plans.map((plan, index) => {
            const isTrial = plan.package_type === "Trial";
            const showSubscribe = isTrialSelected && !isTrial;
            const showAddUser = isBasicOrAdvanceSelected && subscriptionDetails && subscriptionDetails.package_id === plan.package_id;
            const showUpgrade = isBasicSelected && plan.package_type === "Advance";

            return (
              <div
                key={plan.package_id}
                className={`plan-column ${plan.package_type === "Basic" ? 'popular' : ''} ${selectedPlan === plan.package_id ? 'selected-plan' : ''}`}
                onClick={() => handlePlanSelect(plan.package_id)}
                style={{
                  ...customStyles.planColumn,
                  ...(selectedPlan === plan.package_id ? customStyles.selectedPlan : {}),
                  backgroundColor: selectedPlan === plan.package_id ? '#fff8f5' : 'white',
                  borderColor: selectedPlan === plan.package_id ? "#fd5f07" : 'transparent',
                  transform: selectedPlan === plan.package_id ? 'translateY(-5px)' : 'translateY(0)',
                  padding: "2px",
                  borderRadius: "8px"
                }}
              >
                <div className="column-header">
                  {plan.package_type === "Basic" && <div className="popular-ribbon">Most Popular</div>}
                  <h3 style={{ color: "#fd5f07" }}>{plan.package_name}</h3>
                  <div className="price">
                    {/* Free Trial: no price */}
                    {plan.package_type !== "Trial" ? (
                      <>
                        <span className="amount">
                          {isAnnual
                            ? (plan.monthly_price_user_billed_annually
                                ? `₹${plan.monthly_price_user_billed_annually}`
                                : "-")
                            : (plan.monthly_price_per_user
                                ? `₹${plan.monthly_price_per_user}`
                                : "-")}
                        </span>
                        <span className="period">
                          {isAnnual
                            ? ` / user/month`
                            : ` / user/month`}
                        </span>
                      </>
                    ) : (
                      <span className="amount" style={{ color: "#28a745" }}>Free</span>
                    )}
                  </div>
                </div>

                {/* Features mapping */}
                {allFeatures.map((feature, idx) => {
                  const included = plan.features.some(f => f.feature_id === feature.feature_id);
                  return (
                    <div key={feature.feature_id} className="feature-row">
                      {included ? (
                        <div className="feature-included" style={{ color: "#fd5f07" }}>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className="mobile-feature-name">{feature.feature_name}</span>
                        </div>
                      ) : (
                        <div className="feature-excluded">
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 6L18 18" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className="mobile-feature-name">{feature.feature_name}</span>
                        </div>
                      )}
                    </div>
                  );
                })}

                <div className="column-footer">
                  {isTrial ? (
                    selectedPlan === plan.package_id ? (
                      <button
                        className="subscribe-btn"
                        style={{
                          ...customStyles.buttonTransition,
                          backgroundColor: "#cccccc",
                          color: "#888",
                          cursor: "not-allowed",
                          opacity: 1,
                          transform: "scale(1.05)"
                        }}
                        disabled
                      >
                        Subscribed
                      </button>
                    ) : (
                      <button
                        className="subscribe-btn"
                        style={{
                          ...customStyles.buttonTransition,
                          backgroundColor: "#cccccc",
                          color: "#888",
                          cursor: "not-allowed",
                          opacity: 1
                        }}
                        disabled
                      >
                        Subscribed
                      </button>
                    )
                  ) : showSubscribe ? (
                    <button
                      className="subscribe-btn"
                      style={{
                        ...customStyles.buttonTransition,
                        backgroundColor: isSuspended ? "#ccc" : "#fd5f07",
                        color: isSuspended ? "#888" : 'white',
                        boxShadow: "none",
                        cursor: isSuspended ? 'not-allowed' : 'pointer',
                        opacity: isSuspended ? 0.6 : 1
                      }}
                      onClick={e => {
                        e.stopPropagation();
                        if (!isSuspended) handleAddUsersClick(plan, true, false); // subscribeMode = true
                      }}
                      disabled={isSuspended}
                      title={isSuspended ? "Actions disabled - Organization is suspended" : ""}
                    >
                      Subscribe
                    </button>
                  ) : showUpgrade ? (
                    <button
                      className="subscribe-btn"
                      style={{
                        ...customStyles.buttonTransition,
                        backgroundColor: isSuspended ? "#ccc" : "#fd5f07",
                        color: isSuspended ? "#888" : 'white',
                        boxShadow: "none",
                        cursor: isSuspended ? 'not-allowed' : 'pointer',
                        opacity: isSuspended ? 0.6 : 1
                      }}
                      onClick={e => {
                        e.stopPropagation();
                        if (isSuspended) return;
                        setDialogPlan(plan);
                        setUpgradeMode(true);
                        setUpgradeMode2(false); // Ensure renew popup is closed
                        setUpgradeUsersCount(1); // Reset upgrade users count
                        setUpgradeUsersCount2(1); // Reset renew users count
                        setCalculatedPrice(null);
                        setUpgradeStartDate(''); // Reset start date
                      }}
                      disabled={isSuspended}
                      title={isSuspended ? "Actions disabled - Organization is suspended" : ""}
                    >
                      Upgrade Plan
                    </button>
                  ) : showAddUser ? (
                    <div className="d-flex flex-column gap-2 " style={{ width: "225px" }}>
                      <button
                        className="subscribe-btn"
                        style={{
                          ...customStyles.buttonTransition,
                          backgroundColor: isSuspended ? "#ccc" : "#fd5f07",
                          color: isSuspended ? "#888" : 'white',
                          boxShadow: "none",
                          cursor: isSuspended ? 'not-allowed' : 'pointer',
                          opacity: isSuspended ? 0.6 : 1
                        }}
                        onClick={e => {
                          e.stopPropagation();
                          if (isSuspended) return;
                          // Open AddUserPopup
                          setDialogPlan(plan);
                          setAddUsersMode(true);
                          setDialogOpen(true);
                          setCalculatedPrice(null);
                          setUpgradeMode2(false); // Ensure renew popup is closed
                          setUpgradeMode(false); // Ensure upgrade popup is closed
                          setUpgradeUsersCount(1); // Reset upgrade users count
                          setUpgradeUsersCount2(1); // Reset renew users count
                          setUpgradeStartDate(''); // Reset start date
                        }}
                        disabled={isSuspended}
                        title={isSuspended ? "Actions disabled - Organization is suspended" : ""}
                      >
                        Add User
                      </button>
                      <button
                        className="subscribe-btn mb-2"
                        style={{
                          ...customStyles.buttonTransition,
                          backgroundColor: isSuspended ? "#ccc" : "#fd5f07",
                          color: isSuspended ? "#888" : 'white',
                          boxShadow: "none",
                          cursor: isSuspended ? 'not-allowed' : 'pointer',
                          opacity: isSuspended ? 0.6 : 1
                        }}
                        onClick={e => {
                          e.stopPropagation();
                          if (isSuspended) return;
                          setDialogPlan(plan);
                          setUpgradeMode2(true);
                          setUpgradeMode(false); // Ensure upgrade popup is closed
                          setCalculatedPrice(null);
                          setDialogOpen(false); // Close the other dialog
                          setAddUsersMode(false); // Ensure add users mode is off
                          setSubscribeMode(false); // Ensure subscribe mode is off
                          setUpgradeUsersCount2(1); // Reset renew users count
                          setUpgradeUsersCount(1); // Reset upgrade users count
                          setUpgradeStartDate(''); // Reset start date
                        }}
                        disabled={isSuspended}
                        title={isSuspended ? "Actions disabled - Organization is suspended" : ""}
                      >
                        Renew Package
                      </button>
                    </div>
                  ) : (
                    <button
                      className="subscribe-btn"
                      style={{
                        ...customStyles.buttonTransition,
                        backgroundColor: isSuspended ? "#ccc" : "#fd5f07",
                        color: isSuspended ? "#888" : 'white',
                        boxShadow: isSuspended ? "none" : (selectedPlan === plan.package_id ? `0 4px 14px 0 #fd5f0733` : "none"),
                        cursor: isSuspended ? 'not-allowed' : 'pointer',
                        opacity: isSuspended ? 0.6 : 1,
                        transform: selectedPlan === plan.package_id ? 'scale(1.05)' : 'scale(1)'
                      }}
                      onClick={e => {
                        e.stopPropagation();
                        if (!isSuspended) handleAddUsersClick(plan, false, false);
                      }}
                      disabled={isSuspended}
                      title={isSuspended ? "Actions disabled - Organization is suspended" : ""}
                    >
                      Renew  Package
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Add Users / Subscribe / Add User Dialog */}
      {dialogOpen && dialogPlan && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(0,0,0,0.25)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
          onClick={handleDialogClose}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              minWidth: 320,
              maxWidth: 400,
              padding: 28,
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              position: "relative"
            }}
            onClick={e => e.stopPropagation()}
          >
            <h4 style={{ margin: 0, marginBottom: 18, color: "#fd5f07" }}>
              {subscribeMode ? "Subscribe to" : addUsersMode ? "Add User to" : "Add Users to"} {dialogPlan.package_name}
            </h4>
            {/* Add User Mode: show current users and add users input */}
            {addUsersMode ? (
              <>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: "block", fontWeight: 1000, marginBottom: 4 }}>Current Users</label>
                  <input
                    type="number"
                    value={subscriptionDetails?.max_users || 0}
                    disabled
                    style={{ width: "100%", padding: 6, borderRadius: 4, border: "1px solid #ccc", background: "#f5f5f5" }}
                  />
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: "block", fontWeight: 1000, marginBottom: 4 }}>Add no of users</label>
                  <input
                    type="number"
                    min={1}
                    value={addUsersCount}
                    onChange={e => setAddUsersCount(Number(e.target.value))}
                    style={{ width: "100%", padding: 6, borderRadius: 4, border: "1px solid #ccc" }}
                  />
                </div>
              </>
            ) : (
              <>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: "block", fontWeight: 1000, marginBottom: 4 }}>Number of Users</label>
                  <input
                    type="number"
                    min={dialogPlan.min_users || 1}
                    value={userCount}
                    onChange={e => setUserCount(Number(e.target.value))}
                    style={{ width: "100%", padding: 6, borderRadius: 4, border: "1px solid #ccc" }}
                  />
                  <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>
                    Minimum {dialogPlan.min_users} users required
                  </div>
                </div>
                {/* Show Subscription Start Date if subscribeMode */}
                {subscribeMode && (
                  <div style={{ marginBottom: 14 }}>
                    <label style={{ display: "block", fontWeight: 1000, marginBottom: 4 }}>Subscription Start Date</label>
                    <input
                      type="date"
                      value={startDate}
                      onChange={e => {
                        setStartDate(e.target.value);
                        console.log("SubscribePopup: startDate changed", e.target.value);
                      }}
                      style={{ width: "100%", padding: 6, borderRadius: 4, border: "1px solid #ccc" }}
                    />
                  </div>
                )}
                {/* Only show frequency if not subscribeMode */}
                {!subscribeMode && (
                  <div style={{ marginBottom: 18 }}>
                    <label style={{ display: "block", fontWeight: 1000, marginBottom: 4 }}>Billing Frequency</label>
                    <div>
                      <label style={{ marginRight: 16 }}>
                        <input
                          type="radio"
                          name="billingFreq"
                          value="monthly"
                          checked={billingFreq === "monthly"}
                          onChange={() => setBillingFreq("monthly")}
                        /> Monthly
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="billingFreq"
                          value="yearly"
                          checked={billingFreq === "yearly"}
                          onChange={() => setBillingFreq("yearly")}
                        /> Yearly
                      </label>
                    </div>
                  </div>
                )}
                {/* Error message display */}
                {calculatedPrice === 0 && (
                  <div style={{ color: "red", textAlign: "center", marginBottom: 8 }}>
                    Please fill all required fields and try again.
                  </div>
                )}
                {/* Show Pay Now button when calculatedPrice is set */}
                {calculatedPrice !== null && (
                  <div style={{ marginTop: 18, textAlign: "center" }}>
                    <span style={{ fontWeight: 600, color: "#fd5f07", fontSize: 18 }}>
                      Total Price: ₹{calculatedPrice}
                    </span>
                    <div style={{ fontSize: 13, color: "#888" }}>
                      {`(for ${userCount} users, ${isAnnual ? "12 months" : "30 days"})`}
                    </div>
                    {/* Add Pay Now button for subscribeMode */}
                    {subscribeMode && (
                      <button
                        style={{
                          background: isSuspended ? "#ccc" : "#28a745",
                          color: isSuspended ? "#888" : "#fff",
                          border: "none",
                          borderRadius: 6,
                          padding: "10px 32px",
                          fontWeight: 600,
                          fontSize: 16,
                          cursor: isSuspended ? "not-allowed" : "pointer",
                          marginTop: 10,
                          opacity: isSuspended ? 0.6 : 1
                        }}
                        disabled={isSuspended}
                        title={isSuspended ? "Actions disabled - Organization is suspended" : ""}
                        onClick={isSuspended ? undefined : async () => {
                          try {
                            const payload = {
                              billingFrequency: isAnnual ? "YEARLY" : "MONTHLY",
                              subscriptionAction: "RENEW",
                              totalUser: userCount,
                              packageId: dialogPlan.package_id,
                              subscriptionStartDate: formatDateForPayload(startDate),
                              amount: calculatedPrice
                            };
                            const response = await payPlanAmount(payload);
                            if (response && response.paymentLink) {
                              if (response.subscriptionId) {
                                localStorage.setItem('subscriptionId', response.subscriptionId);
                              }
                              window.location.href = response.paymentLink;
                            }
                            handleDialogClose();
                          } catch (error) {
                            // Optionally show error
                          }
                        }}
                      >
                        Pay Now
                      </button>
                    )}
                  </div>
                )}
              </>
            )}
            <button
              onClick={() => {
                handleDialogClose();
                setCalculatedPrice(null);
              }}
              style={{
                position: "absolute",
                top: 8,
                right: 12,
                background: "none",
                border: "none",
                fontSize: 22,
                color: "#888",
                cursor: "pointer"
              }}
              title="Close"
            >
              &times;
            </button>
          </div>
        </div>
      )}

      {/* Add User Popup */}
      <AddUserPopup
        open={addUsersMode}
        onClose={() => {
          setAddUsersMode(false);
          setDialogPlan(null);
          setCalculatedPrice(null);
        }}
        plan={dialogPlan}
        subscriptionDetails={subscriptionDetails}
        addUsersCount={addUsersCount}
        setAddUsersCount={setAddUsersCount}
        calculatedPrice={calculatedPrice}
        setCalculatedPrice={setCalculatedPrice}
      />

      {/* Upgrade Plan Popup */}
      <UpgradePlanPopup
        open={upgradeMode}
        onClose={() => {
          setUpgradeMode(false);
          setDialogPlan(null);
          setCalculatedPrice(null);
          setUpgradeStartDate(''); // Reset on close
          setUpgradeUsersCount(1); // Reset on close
        }}
        plan={dialogPlan}
        subscriptionDetails={subscriptionDetails}
        upgradeUsersCount={upgradeUsersCount}
        setUpgradeUsersCount={setUpgradeUsersCount}
        calculatedPrice={calculatedPrice}
        setCalculatedPrice={setCalculatedPrice}
        startDate={upgradeStartDate}
        setStartDate={setUpgradeStartDate}
      />

      {/* Renew Package Popup */}
      <UpgradePlanPopup2
       open={upgradeMode2}
       onClose={() => {
         setUpgradeMode2(false);
         setDialogPlan(null);
         setCalculatedPrice(null);
         setUpgradeStartDate(''); // Reset on close
         setUpgradeUsersCount2(1); // Reset on close
       }}
       plan={dialogPlan}
       subscriptionDetails={subscriptionDetails}
       upgradeUsersCount2={upgradeUsersCount2}
       setUpgradeUsersCount2={setUpgradeUsersCount2}
       calculatedPrice={calculatedPrice}
       setCalculatedPrice={setCalculatedPrice}
       startDate={upgradeStartDate}
       setStartDate={setUpgradeStartDate}
      />

      <div className="support-section">
        <p>
          Need help deciding? <a href="#" className="contact-link" style={{ color: "#fd5f07" }}>Contact our sales team</a>
        </p>
      </div>
    </div>
  );
}

export default Subscription;